module.exports = __webpack_public_path__ + "img/search.566cdfd2.svg";